import { postChatCompletion } from '@/services/chatApi'
import { patchPendingFromCompletion } from './patchPendingFromCompletion'

/** @param {{ tid: string, pendingId: string, signal: AbortSignal, setMessagesByThreadId: Function, apiMessages: object[], mode?: string }} p */
export function scheduleCompletionUpdate(p) {
  const { tid, pendingId, signal, setMessagesByThreadId, apiMessages, mode } = p
  const req = { messages: apiMessages, signal }
  if (mode !== undefined) req.mode = mode
  void postChatCompletion(req).then((result) => {
    if (result.ok === false && result.code === 'ABORTED') return
    setMessagesByThreadId((inner) => {
      const list = [...(inner[tid] ?? [])]
      const patched = patchPendingFromCompletion(list, pendingId, result)
      if (!patched) return inner
      return { ...inner, [tid]: patched }
    })
  })
}
